import { VStack, Box, Col, Row } from "@reverb-ui/react";
import { SortedTable } from "presentation/components/SortedTable";
import { useContext } from "react";
import { MetricCard } from "../../components/MetricCard";
import { TrafficSourceSummaryContext } from "../context-api";
import { IconVariationEnum } from "data/constants/constants";
import { SortedTableSkeleton } from "presentation/components/Skeleton/SortedTableSkeleton";
import { ListCardSkeleton } from "presentation/components/Skeleton/CardSkeleton";
import { panelsInfo } from "helper/panelsHelper";
import PanelContainer from "presentation/components/PanelContainer";

const trafficSourceSummaryInfo = panelsInfo.trafficSourceSummary;

export const TrafficSourceSummaryReports = () => {
  const {
    requestParamsIndex,
    trafficSourceSummaryData,
    downloadSourceSummaryReport,
    downloadingReports,
    isLoading,
  } = useContext(TrafficSourceSummaryContext);

  const { trafficSourceSummary } = trafficSourceSummaryData || {};
  const { dataRows, dataColumns } = trafficSourceSummary || {};
  return (
    <PanelContainer
      panelId={trafficSourceSummaryInfo.htmlId}
      panelName={trafficSourceSummaryInfo.description}
      rangeName={trafficSourceSummaryData?.range}
      isLoading={isLoading}
      downloadOptions={{
        onClickGenerateCSV: downloadSourceSummaryReport,
        downloadingReports: downloadingReports,
        panelInfo: trafficSourceSummaryInfo,
        filterStateIndex: requestParamsIndex,
      }}
    >
      <Row>
        <Col
          col={
            !isLoading && trafficSourceSummaryData?.cards.length === 0 ? 0 : 3
          }
        >
          {isLoading ? (
            <ListCardSkeleton
              numberOfCards={2}
              spacingBetween={5}
              hasSubText={true}
              hasVariationPeriod={true}
            />
          ) : (
            <VStack w="full" spacing={5}>
              {trafficSourceSummaryData?.cards.map((item, index) => (
                <MetricCard
                  key={index}
                  order={item.order}
                  iconName={item.iconTitle}
                  title={item.title}
                  description={item.text}
                  variation={item.percentageVariation}
                  variationPeriod={item.previousRange}
                  variationType={item.iconVariation as IconVariationEnum}
                  subDescription={item.subText}
                />
              ))}
            </VStack>
          )}
        </Col>
        <Col
          col={
            !isLoading && trafficSourceSummaryData?.cards.length === 0 ? 12 : 9
          }
          className="col-sorted-table"
        >
          <Box
            bg="white"
            w="full"
            p={6}
            height={400}
            overflow="auto"
            className="sortedTable"
          >
            {isLoading ? (
              <SortedTableSkeleton />
            ) : (
              <SortedTable
                dataColumns={dataColumns || []}
                dataRows={dataRows || []}
              />
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
